import { ChartData } from '@/domain/dienstplan/features/StackedChart/utils/types';

export function calculateMaxMitarbeiterAnzahl(chartData: ChartData): number {
  let maxMitarbeiterAnzahl = 0;
  Object.values(chartData).forEach((polygons) => {
    for (const points of polygons) {
      for (const point of points) {
        maxMitarbeiterAnzahl = Math.max(point.y, maxMitarbeiterAnzahl);
      }
    }
  });
  return maxMitarbeiterAnzahl;
}
